// style
import '../css/style.scss';

// libs
import 'swiper/css/bundle';
import Swiper from "swiper";
import * as SwiperModules from "swiper/modules";
Swiper.use(Object.values(SwiperModules));

import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { Fancybox } from '@fancyapps/ui'; // JS Fancybox
Fancybox.bind("[data-fancybox]");
// components

function importAll(r) {
  r.keys().forEach(r);
}

importAll(require.context('./../../assets/resource/fonts/', true, /\.(woff|woff2|eot|ttf|otf)$/));

// Импортируем все файлы js и scss из каждой подпапки 'components'
importAll(require.context('./../../components', true, /\.js$/));
importAll(require.context('./../../components', true, /\.scss$/));

// Импортируем все файлы js и scss из каждой подпапки 'blocks'
importAll(require.context('./../../blocks', true, /\.js$/));
importAll(require.context('./../../blocks', true, /\.scss$/));

// Импортируем все файлы js папки 'utils'
importAll(require.context('./utils', true, /\.js$/));

